import { useStaticQuery, graphql } from "gatsby";
import { UsStatesCovidCasesQuery } from "../../../graphql-types";

export const useUSStatesCovidCases = () => {
  const USStatesCovidCasesCovidCasesData = useStaticQuery<
    UsStatesCovidCasesQuery
  >(graphql`
    query USStatesCovidCases {
      askAboutQuery {
        covidCaseUSStates {
          ...StateCasesFrament
        }
      }
    }
  `);

  return USStatesCovidCasesCovidCasesData.askAboutQuery.covidCaseUSStates;
};
